/**
 * Render info empty list of companies available for user to create an employer profile
 */
import React, { Component } from 'react';
import i18n from '../../../../shared/locales/no.json';

class OnboardingEmptyCompanyResult extends Component {
    render() {
        return (
            <div className="u-text-center">
                {i18n['We do not find any company on your user']}
            </div>
        );
    }
}

export default OnboardingEmptyCompanyResult;
